import { useEffect, useState } from "react";
import { api } from "../../lib/api";

export const inputCls =
  "w-full rounded-xl border border-ngo-deep/20 bg-white px-4 py-3 text-sm text-ngo-ink focus:outline-none focus:ring-2 focus:ring-ngo-leaf/50 transition-[box-shadow] duration-200";

export function errMsg(err) {
  return err?.response?.data?.detail || "कुछ गलत हो गया। कृपया पुनः प्रयास करें।";
}

export function useCategories() {
  const [cats, setCats] = useState([]);
  const load = () => api.get("/categories").then((r) => setCats(r.data.items || [])).catch(() => {});
  useEffect(() => { load(); }, []);
  return [cats, load];
}

export function useUpload() {
  const [uploading, setUploading] = useState(false);
  const upload = async (file, opts = {}) => {
    const fd = new FormData();
    fd.append("file", file);
    const params = new URLSearchParams();
    if (opts.kind) params.set("kind", opts.kind);
    if (opts.context) params.set("context", opts.context);
    if (opts.category) params.set("category", opts.category);
    const r = await api.post(`/admin/upload?${params.toString()}`, fd, {
      onUploadProgress: opts.onProgress,
      headers: { "Content-Type": "multipart/form-data" },
    });
    return r.data;
  };
  return { upload, uploading, setUploading };
}

export function CategorySelect({ value, onChange, testid, allowEmpty = false, emptyLabel = "— श्रेणी चुनें —" }) {
  const [cats] = useCategories();
  return (
    <select data-testid={testid} className={inputCls} value={value} onChange={(e) => onChange(e.target.value)}>
      {allowEmpty && <option value="">{emptyLabel}</option>}
      {!allowEmpty && <option value="">— श्रेणी चुनें —</option>}
      {cats.map((c) => (
        <option key={c.slug} value={c.slug}>{c.name_hi}</option>
      ))}
    </select>
  );
}

export function UploadPicker({ onUploaded, kind = "image", context = "", category = "", label, testid, accept = "image/*" }) {
  const { upload } = useUpload();
  const [busy, setBusy] = useState(false);
  const onFile = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      const r = await upload(f, { kind, context, category });
      onUploaded(r.url);
    } catch (err) {
      alert(errMsg(err));
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };
  return (
    <label data-testid={testid} className={`shrink-0 inline-flex items-center gap-1.5 px-4 rounded-xl bg-ngo-mint text-ngo-deep text-xs font-bold cursor-pointer hover:bg-ngo-leaf/20 transition-colors duration-200 ${busy ? "opacity-50 pointer-events-none" : ""}`}>
      {busy ? "अपलोड हो रहा है..." : label || "अपलोड"}
      <input type="file" accept={accept} className="hidden" disabled={busy} onChange={onFile} />
    </label>
  );
}
